import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { _DocumentatioPage } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";

export interface DocumentatioPageSelectResult {
    PageID: number;
    Name: string;
}

interface BaseProps {
    label?: string;
    IDSelect?: number | number[];
}

interface SingleSelectProps extends BaseProps {
    multiSelect?: false;
    onChange: (value: DocumentatioPageSelectResult) => void;
}

export const EditorDocumentatioPage = ({ label, onChange, multiSelect }: SingleSelectProps) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_DocumentatioPage);
    const paginador = usePaginator();

    const [valor, setValor] = useState<string>("");

    const modal = useModal("Paginas Disponibles", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const returnData = () => {
        if (!bean.PageID) {
            toast.error("Documento no valido");
        } else {
            setValor(`${bean.PageID} - ${bean.Name}`);

            (onChange as (value: DocumentatioPageSelectResult) => void)(bean);

            modal.close();
        }
    };

    const getLista = () => {
        instance.getPages(null, null, data).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    setLista(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'PageID', visible: true },
        { title: 'Nombre pagina', property: 'Name', visible: true },
    ];

    const [listaResult, setListaResult] = useState<any>([]);
    const clearSelection = () => {
        setValor("");
        (onChange as (value: DocumentatioPageSelectResult | null) => void)(null as any);
        setBean({});
    };

    const [data, setData] = useState<string>("")

    return (
        <>
            <label>{label ?? "Linea de Credito"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: '35px', cursor: "pointer" }}
                onClick={() => modal.open()}
            >
                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(e) => {
                                e.stopPropagation(); // evita que abra el modal
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal.modal} updateModal={modal.setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-4">
                        <label>Buscar</label>
                        <input type="text" value={data} onChange={(e) => { setData(e.target.value) }} className="form-control" />
                    </div>
                    <div className="col-md-4">
                        <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <div className="col-md-12">
                        {multiSelect ?
                            <BasicMultiSelectTable clearnotListBody body={lista} bodyResult={listaResult} head={head} keyId="PageID" updateValues={({ bodyResult }) => { setListaResult(bodyResult) }} />
                            :
                            <BasicTable body={lista} head={head} rowSet={setBean} />
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}